import {apiCall} from "@ui/api/common";

export type TSendCodeResponse = {
  email: string
  secondsToRefresh: number
}

export const updateUser = (userId: string, data: {email: string, firstName?: string, lastName?: string}): Promise<void> =>
  apiCall({baseUrl: ""}).put(process.env.UPDATEUSER_URL + "/" + userId, data)

type TUserInfo = {
  email: string
  family_name: string
  given_name:string
  sub: string
  email_verified: boolean
}

export const userInfo = (): Promise<TUserInfo> =>
  apiCall({baseUrl: ""}).get(process.env.USERINFO_URL || "")
